import saveAuthState from '../actions/persist-auth-state';
import {FetchBaseQueryError} from '@reduxjs/toolkit/dist/query';
import {application} from 'constants/application';
import {AuthResponse} from 'services/api/response-types';
import {ApiEndpointBuilder} from 'services/api/types';
import {getDeviceId} from 'services/auth-service';
import {RootState} from 'store';

const confirmRegistrationEndpoint = (builder: ApiEndpointBuilder) => {
  return builder.mutation({
    async queryFn(info: {}, {getState, dispatch}, extra, fetchWithBaseQuery) {
      const {fcmToken, socialAuth} = (getState() as RootState).auth;
      const result = await fetchWithBaseQuery({
        url: 'oauth/register',
        method: 'POST',
        body: {
          ...info,
          provider_token: socialAuth.provider_token,
          provider_name: socialAuth.provider_name,
          fcm_token: fcmToken,
          device_name: getDeviceId(),
          platform: application.platform,
        },
      });
      if (result.error) {
        return {error: result.error as FetchBaseQueryError};
      }
      dispatch(saveAuthState(result.data as AuthResponse));
      return result;
    },
  });
};

export default confirmRegistrationEndpoint;
